module.exports = __webpack_public_path__ + "assets/img/ab1.77317486.png";